<template>
  <div class="card card-pad-lg h-100">
    <div class="section-title">Tickets por Canal</div>
    <div style=" margin-top:8px;">
      <highcharts :options="options" />
    </div>

    <!-- Cajitas estilo captura -->
    <div class="ticket-boxes">
      <div v-for="row in legend" :key="row.label" class="ticket-box">
        <p class="label">{{ row.label }}</p>
        <p class="value">{{ row.value }} tickets</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BarCard',
    props: {
      options: { type: Object, required: true },
      legend: { type: Array, default: () => [] }
    }
  }
</script>

<style scoped>
  .ticket-boxes {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    gap: 12px;
  }

  .ticket-box {
    flex: 1;
    text-align: center;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px;
  }

  .ticket-box .label {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 4px;
  }

  .ticket-box .value {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
  }
</style>
